export const shouldBeWidgetsInitMinimized = window.innerWidth < 1200;
